import React, { FunctionComponent } from 'react';
import { ButtonProps } from '@material-ui/core/Button';
import { MuiOverrideableProps } from '../../../type/MuiOverrideableProps';
import { ExtendButtonBaseTypeMap } from '@material-ui/core/ButtonBase/ButtonBase';
import { ButtonTypeMap } from '@material-ui/core/Button/Button';
import buttonOptionToggleStyles from './buttonOptionToggleStyles';
import ButtonWithIcon from './ButtonWithIcon';
import Translation from '../../translation/Translation';

interface IButtonOptionToggleProps {
  label: string;
  labelRemove: string;
  isEnabled?: boolean;
  iconSize?: number;
}

const ButtonOptionToggle: FunctionComponent<
  MuiOverrideableProps<ButtonProps, ExtendButtonBaseTypeMap<ButtonTypeMap>> & IButtonOptionToggleProps
> = ({ className = '', label, labelRemove, isEnabled, iconSize = 44, ...props }) => {
  const styles = buttonOptionToggleStyles(props);

  return (
    <ButtonWithIcon
      {...props}
      className={[styles.root, className, isEnabled && styles.enabled].join(' ')}
      iconSize={iconSize}
      variant={'contained'}
      iconClasses={[styles.icon, isEnabled && styles.iconRemove].join(' ')}
    >
      <Translation id={isEnabled ? labelRemove : label} />
    </ButtonWithIcon>
  );
};

export default ButtonOptionToggle;
